<template>
	<div id="app" class="fluid text-dark">
		<mdb-container fluid>
			<mdb-row>
				<mdb-col col="12" sm="3_67" md="3" lg="2_67" xl="1_67" id="left-column">
					<app-brand :class="brandClass"/>
					<app-menu :class="menuClass"/>
				</mdb-col>
				<mdb-col col="12" :sm="smCenter" :md="mdCenter" :lg="lgCenter" :xl="xlCenter" id="center-column">
					<app-header ref="header"/>
					<router-view/>
					<app-footer ref="footer"/>
				</mdb-col>
			</mdb-row>
		</mdb-container>
		<app-errors/>
	</div>
</template>

<script>
import AppHeader from './Header.vue'
import AppBrand from './Brand.vue'
import AppMenu from './Menu.vue'
import AppFooter from './Footer.vue'
import AppErrors from './Errors.vue'
import {mapState} from "vuex";

export default {
	name: 'Layout',
	components: { AppBrand, AppHeader, AppMenu, AppFooter, AppErrors },
	computed: {
		viewHeight () {
			return Math.max(window.innerHeight, this.$el.clientHeight) - this.$refs.header.$el.clientHeight - this.$refs.footer.$el.clientHeight
		},
		smCenter() {
			return this.hidePanel ? '' : '8_33'
		},
		mdCenter() {
			return this.hidePanel ? '' : '9'
		},
		lgCenter() {
			return this.hidePanel ? '' : '9_33'
		},
		xlCenter() {
			return this.hidePanel ? '' : '10_33'
		},
		brandClass () {
			return this.hidePanel ? 'd-sm-none' : ''
		},
		menuClass () {
			return this.hidePanel ? 'd-none' : ''
		},
		...mapState(['hidePanel'])
	}
}
</script>

<style scoped>

</style>
